const extractAxiosMessage = (error) => {
  const message =
    (error.response && error.response.data && error.response.data.message) ||
    error.toString();
  return message;
};

export default extractAxiosMessage;
